import React from 'react'
import { FaTimes } from 'react-icons/fa'
import { CurrencyInput, Input, Text } from 'components'
import styles from '../ProposalWizard.module.scss'

const ProposalDataSection = ({
  form,
  touched,
  errors,
  onChange,
  onBlur,
  onAddAttachment,
  onRemoveAttachment,
}) => (
  <section className={styles.section}>
    <p className={styles.sectionTitle}>
      <span className={styles.sectionNumber}>2</span>
      Dados da proposta
    </p>
    <CurrencyInput
      id="proposalValue"
      label="Valor Total da Proposta (c/ honorários inclusos)*"
      description="Insira aqui o valor total proposto pelo cliente para o imóvel, incluindo os honorários de venda."
      className={styles.currencyInput}
      value={form.proposalValue}
      onChange={(id, value) => onChange(id, value)}
      autoComplete="off"
      disableAbbreviations
      hasError={touched.proposalValue && !errors.isProposalValueValid}
      errorMessage={
        errors.isProposalValueBelowMin
          ? '⚠️ Valor abaixo da faixa de negociação.'
          : 'Campo obrigatório'
      }
      onBlur={onBlur('proposalValue')}
    />
    <Input
      id="justification"
      label="Justificativa para o valor proposto*"
      description="Explique brevemente os motivos do valor proposto (mínimo de 30 caracteres)."
      className={styles.wizardTextarea}
      rows={4}
      maxLength={1000}
      placeholder="Digite aqui sua justificativa..."
      value={form.justification}
      onChange={e => onChange('justification', e.target.value)}
      onBlur={onBlur('justification')}
      hasError={touched.justification && !errors.isJustificationValid}
      errorMessage={
        form.justification?.trim()
          ? 'Conte um pouco mais sobre os motivos da sua proposta.'
          : 'Campo obrigatório'
      }
    />
    <span className={styles.charCount}>
      {form.justification?.length || 0}/1000 caracteres
    </span>
    <div className={styles.attachments}>
      <Text fontSize="medium" color="secondaryColor">
        Anexos para justificativa (opcional)
      </Text>
      <Text fontSize="small" color="lightBlueColor">
        Adicione fotos ou documentos que ajudem a justificar sua proposta.
      </Text>
      <label className={styles.attachmentButton} htmlFor="attachments">
        + Adicionar anexos
        <input
          id="attachments"
          type="file"
          multiple
          hidden
          onChange={e => {
            onAddAttachment(Array.from(e.target.files || []))
            e.target.value = ''
          }}
        />
      </label>
      {!!form.attachments?.length && (
        <ul className={styles.attachmentList}>
          {form.attachments.map((file, index) => (
            <li key={`${file.name}-${file.size}`}>
              <span>{file.name}</span>
              <button
                type="button"
                aria-label="Remover anexo"
                onClick={() => onRemoveAttachment(index)}
              >
                <FaTimes />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  </section>
)

export default React.memo(ProposalDataSection)
